/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  if (
    prevRouterProps &&
    routerProps.location.pathname === prevRouterProps.location.pathname
  ) {
    return false
  }
  return true
}
